import { c as _c } from "react/compiler-runtime";
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconLoan from '@/assets/icons/heroIcons/Loan.svg';
import IconWarranty from '@/assets/icons/heroIcons/Warranty.svg';
import IconDevice from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconShopping from '@/assets/icons/heroIcons/Shopping-bag.svg';
import IconShieldCheck from '@/assets/icons/heroIcons/ShieldCheck.svg';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import { Button } from '@/components/buttons';
import { ContentContainer } from '@/components/layout';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import { Link } from '@/components/links';
import { Text } from '@/components/typography';
import { RepresentativeExample } from '@/sections/RepresentativeExample';
import { useProductRegistrationLink } from '@/hooks/useProductRegistrationLink';
function Benefits() {
  const $ = _c(75);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["card"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const registrationLink = useProductRegistrationLink("karta");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bgCircle absolute top-36 right-0 h-44 w-44 translate-x-[45%] rotate-90 lg:top-[32.25rem] lg:right-auto lg:left-0 lg:h-[23.75rem] lg:w-[23.75rem] lg:translate-x-[17%]" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("benefitsSection.title.1");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <SectionHeadline className="mx-auto mb-10 max-w-192 px-0 lg:mb-16" anchorKey="benefitsSection.title.1">{t2}</SectionHeadline>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("benefitsSection.benefits.item.1.title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("benefitsSection.benefits.item.1.paragraph");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconCard />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t5) {
    t7 = {
      title: t4,
      paragraph: t5,
      icon: t6
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("benefitsSection.benefits.item.2.title");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("benefitsSection.benefits.item.2.paragraph");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconLoan />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t8 || $[20] !== t9) {
    t11 = {
      title: t8,
      paragraph: t9,
      icon: t10
    };
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("benefitsSection.benefits.item.3.title");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("benefitsSection.benefits.item.3.paragraph");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <IconWarranty />;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t12 || $[28] !== t13) {
    t15 = {
      title: t12,
      paragraph: t13,
      icon: t14
    };
    $[27] = t12;
    $[28] = t13;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t("benefitsSection.benefits.item.4.title");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t) {
    t17 = t("benefitsSection.benefits.item.4.paragraph");
    $[32] = t;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <IconShopping />;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t16 || $[36] !== t17) {
    t19 = {
      title: t16,
      paragraph: t17,
      icon: t18
    };
    $[35] = t16;
    $[36] = t17;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t) {
    t20 = t("benefitsSection.benefits.item.5.title");
    $[38] = t;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t) {
    t21 = t("benefitsSection.benefits.item.5.paragraph");
    $[40] = t;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <IconShieldCheck />;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t20 || $[44] !== t21) {
    t23 = {
      title: t20,
      paragraph: t21,
      icon: t22
    };
    $[43] = t20;
    $[44] = t21;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t) {
    t24 = t("benefitsSection.benefits.item.6.title");
    $[46] = t;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t) {
    t25 = t("benefitsSection.benefits.item.6.paragraph");
    $[48] = t;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <IconDevice />;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t24 || $[52] !== t25) {
    t27 = {
      title: t24,
      paragraph: t25,
      icon: t26
    };
    $[51] = t24;
    $[52] = t25;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t11 || $[55] !== t15 || $[56] !== t19 || $[57] !== t23 || $[58] !== t27 || $[59] !== t7) {
    t28 = <InfoBoxes variant="basic" items={[t7, t11, t15, t19, t23, t27]} />;
    $[54] = t11;
    $[55] = t15;
    $[56] = t19;
    $[57] = t23;
    $[58] = t27;
    $[59] = t7;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Link to={LINKS().revolving} analyticsParam="cardBenefitsSectionRevolvingLoan" testId="cardBenefitsSectionRevolvingLoan" />;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t) {
    t30 = <Text variant="p4" className="mt-10 text-center text-gray-600 lg:mt-12"><Trans t={t} i18nKey="benefitsSection.benefits.note">{t29}</Trans></Text>;
    $[62] = t;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="mx-auto mt-4 max-w-[47.5rem]"><RepresentativeExample className="bg-white" variant="withoutPostponeDueDateInfo" /></div>;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== t) {
    t32 = t("benefitsSection.benefits.button");
    $[65] = t;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== registrationLink || $[68] !== t32) {
    t33 = <Button variant="primary" size="lg" align="center" testId="cardBenefitsSectionBenefits" analyticsParam="cardBenefitsSectionBenefits" className="mt-10 lg:mt-12" to={registrationLink}>{t32}</Button>;
    $[67] = registrationLink;
    $[68] = t32;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== t28 || $[71] !== t3 || $[72] !== t30 || $[73] !== t33) {
    t34 = <div className="relative overflow-hidden bg-blue-50 px-4 pt-14 pb-20 lg:pt-20 lg:pb-40">{t1}<ContentContainer>{t3}{t28}{t30}{t31}{t33}</ContentContainer></div>;
    $[70] = t28;
    $[71] = t3;
    $[72] = t30;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  return t34;
}
export default Benefits;